import { IReward } from './IReward';
import { Reward } from './Reward';
import StreamingTransactionTypes from './StreamingTransactionTypes';

export class StreamingReward extends Reward {
	public static readonly CLASS: string = 'com.bancvue.rcx.config.product.rewards.api.StreamingReward';

	public static readonly NAME: string = 'Streaming';

	transactionType: string = StreamingTransactionTypes.ALL.value;

	cashBackRate: number = 0;

	purchaseLimit: number = 0;

	constructor(reward?: IReward) {
	  super(StreamingReward.CLASS, reward ? reward.id : null);

	  if (reward) {
	    this.cashBackRate = (reward as any).cashBackRate;
	    this.purchaseLimit = (reward as any).purchaseLimit;
	    this.transactionType = (reward as any).transactionType;
	  }
	}

	getDescription(): string {
	  let description = `Refund of up to $${this.purchaseLimit} of `;

	  switch (this.transactionType) {
	    case StreamingTransactionTypes.VIDEO_STREAMING.value:
	      description += 'video ';
	      break;

	    case StreamingTransactionTypes.AUDIO_STREAMING.value:
	      description += 'audio ';
	      break;

	    case StreamingTransactionTypes.GAMING_STREAMING.value:
	      description += 'gaming ';
	      break;

	    case StreamingTransactionTypes.VIDEO_AUDIO_STREAMING.value:
	      description += 'video or audio ';
	      break;

	    case StreamingTransactionTypes.VIDEO_GAMING_STREAMING.value:
	      description += 'video or gaming ';
	      break;

	    case StreamingTransactionTypes.AUDIO_GAMING_STREAMING.value:
	      description += 'audio or gaming ';
	      break;

	    case StreamingTransactionTypes.ALL.value:
	      description += 'all ';
	      break;

	    default:
	      description += 'unknown ';
	  }

	  description += 'streaming purchases';
	  return description;
	}

	clone(): IReward {
	  const clone = new StreamingReward();
	  Object.assign(clone, this);
	  return clone;
	}
}

export default StreamingReward;
